import DotActiveIcon from './icons/dot-active-web.svg';
import DotDisabledIcon from './icons/dot-web.svg';
import DotCompletedIcon from './icons/dot-completed-web.svg';
import { DotIconProps } from './Props';

export const DotIcon = ({ completed = false, active = false }: DotIconProps) => {
	if (completed) {
		return <DotCompletedIcon />;
	}
	if (active) {
		return <DotActiveIcon />;
	}

	return <DotDisabledIcon />;
};
